import React, { useState, useEffect } from "react";
import { Modal } from "rsuite";
import Button from "../../components/button";
import UserModerationSummary from "./UserModerationSummary";

const ActionConfirmationModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  message, 
  actionText, 
  showReasonInput = false,
  reportData,
}) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!open) setReason('');
  }, [open]);

  const handleConfirm = () => {
    if (showReasonInput && !reason.trim()) return; 
    onConfirm(reason);
  };

  const isConfirmDisabled = showReasonInput && reason.trim().length === 0;

  return (
    <Modal open={open} onClose={onClose} size={reportData ? "lg" : "sm"}>
      <Modal.Header>
        <Modal.Title className="font-semibold text-lg leading-7 tracking-normal">
          Are you absolutely sure?
        </Modal.Title>
        <p className="text-gray-600 mt-1">{message}</p>
      </Modal.Header>

      <Modal.Body style={{ display: "flex", flexDirection: 'column', gap: '16px' }}>
        {reportData && (   
            <div>
              <UserModerationSummary
                selectedUser={reportData}
              />
          </div>
        )}

        {showReasonInput && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Reason for this action
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="w-full border border-gray-300 rounded-md p-2 resize-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              rows={4}
              maxLength={500}
              placeholder="Enter reason for this action..."
            />
            <div className="text-right mt-1">
              <span className="text-xs text-gray-500">
                {reason.length}/500 characters
              </span>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{ borderTop: 'none', paddingTop: '0' }}>
        <div className="flex justify-end gap-3 w-full">
          <Button onClick={onClose} type="secondary">
            Cancel
          </Button>

          <Button 
            type="primary"
            onClick={handleConfirm}
            disabled={isConfirmDisabled}
          >
            {actionText}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ActionConfirmationModal;
